<template>

  <div  :class=cssStyle[curQuestionNumber-1]>


    <div>
    <div class="gameplay_bar"></div>
            <div class="container">
              <timer :seconds="30000" :userAnswer="userHasAnswer"/>

      <div class="gameplay_points">
        <a class="logo-header">
          <router-link to="/" style="cursor:pointer">
            <img src="/static/images/brainiac_logo_white.png" alt="">
          </router-link>
        </a>
      </div>

      <div class="gameplay_score">
        <nav class="main-nav">
          <ul class="main-nav__lang" id="get_started_menu" v-if="!hideLangSelection">
            <li class="dropdown">
              <a>
                <div class="icon-globe"><img src="/static/images/icon-globe-white.svg" alt=""></div> </a>
                  <ul>
                  <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                    <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                  </li>
                </ul>


            </li>
          </ul>
        </nav>

        <input type="checkbox" id="checkbox" class="mobile-menu__checkbox">
        <label for="checkbox" class="mobile-menu__btn" >
          <div class="mobile-menu__icon">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </label>


        <div class="mobile-menu__container">
          <ul class="mobile-menu__list">
            <li class="mobile-menu__item"> <!-- WIN INSTANTLY TODO WHAT ABOUT THIS PAGE-->
              <router-link to="/prizes" :class="['mobile-menu__link', getActiveTabClass('/prizes')]">
                {{ getTranslations.home_win_instantly }}
              </router-link>
            </li>
            <li v-if="!hideLeaderboard" class="mobile-menu__item"> <!-- PRIZES & LEADERBOARDS -->
              <router-link to="/home/prizesAndLeaderBoards" :class="['mobile-menu__link', getActiveTabClass('/home/prizesAndLeaderBoards')]">
                {{ getTranslations.home_home_prizes_and_leaderboards }}
              </router-link>
            </li>
            <li v-if="!hideWinners" class="mobile-menu__item"> <!-- WINNERS -->
              <router-link to="/winners" :class="['mobile-menu__link', getActiveTabClass('/winners')]">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/howItWorks" :class="['mobile-menu__link', getActiveTabClass('/howItWorks')]">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>


              <div v-if="conditionMemory" >
        <img src="static/images/games/letter_white.svg" class="gameplay_list_image" alt="">
        <div class="gameplay_game_box_list">


          <div class="list_title"> {{ getTranslations.visitor_free_trial_memory_question }} </div>

          <div class="gameplay_divider"></div>

          <div class="gameplay_list_items">
            <p> {{ getTranslations.visitor_free_trial_memory_list1 }} </p>
            <p> {{ getTranslations.visitor_free_trial_memory_list2 }} </p>
            <p> {{ getTranslations.visitor_free_trial_memory_list3 }} </p>
            <p> {{ getTranslations.visitor_free_trial_memory_list4 }} </p>
          </div>

          <button type="" class="gameplay_list_button" @click="giveMemoryQuestion"> {{ getTranslations.visitor_free_trial_memory_ok }} </button>

        </div>

      </div>
      <div v-else >

                <div class="gameplay_title_container">
                  <div class="gameplay_title">
                    {{ personalizedData.questionText }}

                  </div>
                </div>

                <div class="gameplay_game_box">


                  <img :src=imageGameUrl[curQuestionNumber-1] class="">
                  <div class="gameplay_divider"></div>

                  <div  v-for="row in (randomizedAnswers.length / 2)" :key="row"  class="gameplay_btns_row" >
                    <button v-for="answer in getPartOfAnswers(row)" :key="answer.answerKey" @click="registerUserAnswer(answer.answerId, answer.answerKey, true)" :class=getAnswerCSSClasses(answer.answerKey) >
                      {{ answer.answerText }}
                    </button>
                  </div>

                </div>
              </div>

    </div>

    <div class="gameplay_footer footer_fixed">
      <p> {{ getTranslations.visitor_free_trial_modals_play_more }} </p>
    </div>

    </div>
    <component :is="componentModalAnswer" />

  </div>

</template>


<script>

/* eslint no-console: "off" */
/* eslint-disable */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { Howl } from 'howler';
import { GameMixin, GameMixin2 } from '@/common/mixins/game';
import Timer from "../../home/game/Timer";
import WrongAnswer from './modals/WrongAnswer';
import Winner from './modals/Winner';
import CorrectAnswer from './modals/CorrectAnswer';
import { handleBurger, handleLanguageDropdown, openCloseTab } from '@/common/jQuery';




const moment = require('moment');
const ProgressBar = require('progressbar.js');




export default {
  name: 'gameFreePlay',
  components: {Timer},
  mixins: [GameMixin, GameMixin2],
  data() {
    return {
      componentModalAnswer: null,
      userHasAnswer: false,
      conditionMemory: false,
      memoryQuestion: false,
      cssChange: false,
      imageGameUrl: ["/static/images/game_images/ attention_02_easy/AT_02_easy_00.jpg","/static/images/game_images/memory_01_easy/MEM_01_easy_00.jpg","/static/images/game_images/logic_01_easy/LOG_01_easy_00.jpg"],
      cssStyle:["gameplay_bg free attention","gameplay_bg free memory","gameplay_bg free logic"],
      curQuestionNumber: 0,
      questionsData: {
        buttonsColour: [["gameplay_btn"] , ["gameplay_btn"] , ["gameplay_btn"] , ["gameplay_btn"]],
         homeUserDetails: {
           score: 0,
           roundDTOList: {
             isWinner: false,
             answerDTOList: {
               0: { answerKey: -1, correct: ''},
               1: { answerKey: -1, correct: ''},
               2: { answerKey: -1, correct: ''},
             }
           },
           questionDTOList: {
              0: {
                  questionId: 1,
                  questionText: 'q1 ?',
                  imageURL:"",
                  answerDTOList: [{ answerKey: 1, answerText: 'choiceA1' }, { answerKey: 2, answerText: 'choiceA2'}, { answerKey: 3, answerText: 'choiceA3'}, { answerKey: 4, answerText: 'choiceA4'}],
                  correct: 4,
              },
              1: {
                 questionId: 2,
                 questionText: 'q2 ?',
                 imageURL:"",
                 answerDTOList: [{ answerKey: 1, answerText: 'choiceB1'}, { answerKey: 2, answerText: 'choiceB2'}, { answerKey: 3, answerText: 'choiceB3'}, { answerKey: 4, answerText: 'choiceB4'}],
                 correct: 4,
              },
              2: {
                  questionId: 3,
                  questionText: 'q3 ?',
                  imageURL:"",
                  answerDTOList: [{ answerKey: 1, answerText: 'choiceC1'}, { answerKey: 2, answerText: 'choiceC2'}, { answerKey: 3, answerText: 'choiceC3'}, { answerKey: 4, answerText: 'choiceC4'}],
                  correct: 4,
              },
           },
         },
      },
      personalizedData: null,
      randomizedAnswers: [],
      playerAnswered: false,
      playerAnswerID: '',
      playerAnswerKey: '',
      isFirstTimeUsingCheatHelp: false,
      currentQuestionID: -1,
      availableAnswers: [],
      bothPlayersAnswered: false,
      questionAnswerTime: 30, // seconds
      secondsElapsed: 0,
      svgTimerCSSClass: '',
      svgTimerPathsCSSClasses: [],
      timer: null,
      // TODO implement playing of all sounds
      selectSound: new Howl({
        src: ['/static/sounds/Select_Answer.ogg', '/static/sounds/Select_Answer.mp3'],
      }),
      rightAnswerSound: new Howl({
        src: ['/static/sounds/right_answer.ogg', '/static/sounds/right_answer.mp3'],
      }),
      wrongAnswerSound: new Howl({
        src: ['/static/sounds/wrong_answer.ogg', '/static/sounds/wrong_answer.mp3'],
      }),
      countDownTimerSound: new Howl({
        src: ['/static/sounds/CountDownTimer.ogg', '/static/sounds/CountDownTimer.mp3'],
      }),
    };
  },
  created() {
   console.log('in free trial Game created hook');
    this.initRoundData();
    this.initQuestionData(this.questionsData);
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger();
    });
    openCloseTab();

  },
  beforeDestroy() {
    console.log('in free trial game\'s beforeDestroy hook');
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations('game', [
      'setCurrentRoundNumber',
      'setCurrentQuestionNumber',
      'resetPlayersAnswersHistoryCSSClasses',
      'setHomePlayerRoundAnswerTime',
      'setCurrentRoundWinner',
      'setGameFinishedStatus',
      'setGameWinner',
    ]),...mapMutations('common', [
      'validTransitionForFreeGameMethod','setFreeUserPrice',
    ]),
    fillUpQuestions() {setTimeout(() => {
      this.checkIfGameMemoryExist();
      Object.keys(this.questionsData.homeUserDetails.questionDTOList).forEach((key) => {
        this.questionsData.homeUserDetails.questionDTOList[key].questionText = this.getTranslations[`visitor_free_trial_question${key}`];
        Object.keys(this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList).forEach((k) => {
          if (parseInt(k) === 3)
            this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList[k].answerText = this.getTranslations[`visitor_free_trial_question${key}_answer_correct`];
          else
            this.questionsData.homeUserDetails.questionDTOList[key].answerDTOList[k].answerText = this.getTranslations[`visitor_free_trial_question${key}_answer${k}`];
        });
      });
    }, 10);

    },
    checkIfGameMemoryExist(){
      if ( this.curQuestionNumber === 2 && ( !this.memoryQuestion ) ){
        this.conditionMemory=true;
      }
      else if ( this.curQuestionNumber === 2 && ( this.secondsElapsed > 10)){
        this.conditionMemory=false;
      }
      else {
        this.conditionMemory=false;
      }

    },
    funct() {
      var element = document.getElementById("blurry");
      element.classList.toggle("blurred_bg");
    },
    sendUserAnswer() {
      this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].correct = (this.playerAnswerKey === this.personalizedData.correct ? 'correct' : 'wrong');
      this.questionsData.homeUserDetails.roundDTOList.answerDTOList[this.curQuestionNumber - 1].answerKey = this.playerAnswerKey;
      this.questionsData.homeUserDetails.score = (this.playerAnswerKey === this.personalizedData.correct ? this.questionsData.homeUserDetails.score + 1 : this.questionsData.homeUserDetails.score);
      //this.getNextCTA();
    },
    initRoundData() {
      this.fillUpQuestions();
    },
    increaseCurrentQuestionNumberByOne() {
      const question=Math.floor(Math.random() * (3 - 1 + 1) ) + 1;
      console.log(`given Question ${question} ...`);
      this.curQuestionNumber = question ;
    },
    initQuestionData(data) {
      console.log('initializing question data...');
      this.increaseCurrentQuestionNumberByOne();
      this.personalizedData = data.homeUserDetails.questionDTOList[this.curQuestionNumber - 1];
      this.randomizedAnswers = this.personalizedData.answerDTOList;
      this.initCommonData();
      this.initAndStartTimerTrial();
    },
    initCommonData() {
      this.playerAnswered = false;
      this.playerAnswerKey = '';
     // this.setHomePlayerAnswer('');
    },
    initAndStartTimerTrial() {
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          if (this.userHasAnswer) {
            clearInterval(this.timer);
          }

          this.checkIfGameMemoryExist();
          this.secondsElapsed += 1;
          if (this.secondsElapsed === this.questionAnswerTime) {
            this.checkForUserAnswer();
            clearInterval(this.timer);
          }
        }, 1000);
      });
      /* eslint-enable */
    },
    giveMemoryQuestion() {
      this.memoryQuestion = true;
    },
    checkForUserAnswer() {
      if (!this.userHasAnswer) {
        console.log('User didnt answer');
        this.registerUserAnswer(1, 1);
      }
    },
    getPartOfAnswers(part) {
      if (part === 1) {
        return this.randomizedAnswers.slice(0, this.randomizedAnswers.length / 2);
      }
      return this.randomizedAnswers.slice(this.randomizedAnswers.length / 2);
    },
    registerUserAnswer(answerID, answerKey) {
      this.validTransitionForFreeGameMethod(false);
      if (!this.userHasAnswer) {
        this.userHasAnswer = true;
        console.log(`Unsub user has answered with answer ${answerKey}...`);
        console.log(this.freeTrialGuaranteedPrize);
        if (!this.playerAnswered && this.curQuestionNumber <= 3) {
          if (answerKey === 4) {
            this.questionsData.buttonsColour[answerKey - 1].push('gameplay_btn gameplay_btn_correct');
            this.getAnswerCSSClasses(answerKey);
            console.log('Unsub user has won!!!');
            this.rightAnswerSound.play();
            this.questionsData.homeUserDetails.roundDTOList.isWinner = true;
            setTimeout(() => {
              this.normalTransition = true;
              this.cssChange = true;
              if (this.freeTrialGuaranteedPrize) {
                this.componentModalAnswer = Winner;
              }
              this.componentModalAnswer = CorrectAnswer;
              this.showModal();
            }, 2000);
          } else {
            this.questionsData.buttonsColour[answerKey - 1].push('gameplay_btn gameplay_btn_false');
            setTimeout(() => {
              this.questionsData.buttonsColour[3].push('gameplay_btn gameplay_btn_correct');
            }, 1000);

            this.getAnswerCSSClasses(answerKey);
            this.wrongAnswerSound.play();
            console.log('Unsub user has lost!!!');
            this.questionsData.homeUserDetails.roundDTOList.isWinner = false;
            setTimeout(() => {
              this.cssChange = true;
              this.normalTransition = true;
              this.componentModalAnswer = WrongAnswer;
              this.showModal();
            }, 2000);
          }
        }
        clearInterval(this.timer);
        setTimeout(() => {
          this.normalTransition = true;
        }, 5000);


        this.questionsData.homeUserDetails.roundDTOList.totalAnswerTimeMillis = this.secondsElapsed * 1000;
        clearInterval(this.timer);
        this.sendUserAnswer();
      }
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $("#wheel_prize_modal").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          this.$router.push('/');
        });
      });
      /* eslint-enable */
    },
    getActiveTabClass(path) {
      this.normalTransition = true;
      return this.currentTabPath === path ? 'active' : '';
    },
    getAnswerCSSClasses(answerKey) {
      return this.questionsData.buttonsColour[answerKey - 1];
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.facebookSDKApi().then(() => {
              this.changeCSSFile();
            });
          });
        });
      });
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'freeTrialGuaranteedPrize',
      'userDetails',
      'freeTrialPoints',
      'hideLangSelection',
      'soundsOn',
      'freeUserPrice',
    ]),
    ...mapState('game', [
      'playersDetails',
      'currentRoundNumber',
      'homePlayerCurrentSelectedTheme',
      'homePlayerRoundScore',
      'homePlayerQuestionDTO',
      'homePlayerAnswer',
      'homePlayerCorrectAnswersCSSClasses',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
    ]),
    getThemeColor() {
      return {
        borderColor: `rgb(${this.homePlayerCurrentSelectedTheme.red},${this.homePlayerCurrentSelectedTheme.green},${this.homePlayerCurrentSelectedTheme.blue})`,
      };
    },
    getQuestionImage() {
      return {
        backgroundImage: `url(${this.personalizedData.imageURL})`,
      };
    },
  },
};
/* eslint-enable */
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GameFreePlay.vue